import React from 'react'
import { Link } from "react-router"
import './ArrrAgency.scss'

const ArrrAgency = () => {
    return (
        <Link
            to={"https://arrr.agency"}
            className={"heading h3 arrr-agency"}
        >
            <span>Сделано в arrr.agency</span>
            <img src={"/misc/arrow-blue.svg"} alt=""/>
        </Link>
    )
}

export default ArrrAgency